import {Injectable} from '@angular/core';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';
import {UmpireComponentFaqQuestion} from '@tisa-group/models';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';
import {Observable} from 'rxjs';

@Injectable()
export class FaqQuestionService implements CrudService<UmpireComponentFaqQuestion> {
  constructor(readonly http: TisaUmpireHttpService) {}

  create(
    body: Partial<UmpireComponentFaqQuestion>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireComponentFaqQuestion>> {
    return this.http
      .post(`/faq/questions`, serialize({stuff: body}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  update(
    body: Partial<UmpireComponentFaqQuestion>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireComponentFaqQuestion>> {
    return this.http
      .patch(`/faq/questions/${body.id}`, serialize({stuff: body}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  delete(id: string): Observable<void> {
    return this.http.delete(`/faq/questions/${id}`);
  }
}
